import { render, staticRenderFns } from "./PageWrapper.vue?vue&type=template&id=79a2f553&scoped=true"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"
import style0 from "./PageWrapper.vue?vue&type=style&index=0&id=79a2f553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a2f553",
  null
  
)

export default component.exports